module.exports = __webpack_public_path__ + "img/icon_map_1_c.dde7f8fe.png";